import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

import {
  userStoreSelector,
  useUserStore,
} from '@repo/editor/src/stores/userStore';
import {
  removeAuthRedirectKey,
  setAuthRedirectKey,
} from '@repo/editor/src/utils/auth';

import { NO_REDIRECT_URLS } from 'global/constants';

export const NO_REDIRECT_URLS_KEYS = Object.fromEntries(
  Object.entries(NO_REDIRECT_URLS).map((x) => [x[1], x[0]])
);

export const useAuthRedirect = (): void => {
  const pathname = usePathname();
  const user = useUserStore(userStoreSelector.loadingUser);

  useEffect(() => {
    if (user === null) {
      if (window.location.pathname === '/authorize') {
        return;
      }

      if (window.location.pathname in NO_REDIRECT_URLS_KEYS) {
        setAuthRedirectKey(NO_REDIRECT_URLS_KEYS[window.location.pathname]);
        return;
      }

      removeAuthRedirectKey();
    }
    // we need router.asPath to trigger useEffect on every path change
  }, [pathname, user]);
};
